import { modalContainer } from "@/src/theme/commonStyle";
import { Theme } from "@mui/material";

const divorceCostBoxStyle = {
  modalContainer,
  costHintText: {
    textAlign: "justify",
    fontSize: 14,
  },
  costRealLabel: {
    fontWeight: 500,
    paddingBottom: 0,
  },
  costRealValue: {
    fontWeight: 500,
    paddingBottom: 0,
    textAlign: "right",
  },
  costButton: {
    paddingLeft: "8px",
    paddingRight: "8px",
    marginTop: ".8rem",
  },
  costDisclaimerText: {
    fontSize: 9,
    lineHeight: 1.5,
    marginBottom: "1rem"
  },
  xsSpace: (theme: Theme) => ({
    [theme.breakpoints.down("sm")]: {
      marginTop: "1rem",
      paddingTop: "1rem",
    },
  }),
  costEstimateLabel: {
    fontSize: "1.25rem",
    fontWeight: 400,
    textAlign: "left",
    marginBottom: ".5rem",
  },
  costEstimateLabelSmall: {
    fontSize: "1.25rem",
  },
  costEstimateValue: {
    fontSize: "1.25rem",
    fontWeight: 500,
  },
  costEstimateValueSmall: {
    fontSize: "1.125rem",
    fontWeight: 500,
  },
  infoIconContainer: {
    textAlign: "right",
    padding: "5px",
  },
  info: {
    height: "20px",
    width: "20px",
    cursor: "pointer",
  },
  primary: {
    color: "primary.main",
  },
  loadingContainer: {
    margin: "50px 230px",
  },
  content: {
    position: "relative",
    padding: "1.5rem",
    height: "100%",
    width: "100%",
  },
  boxGrid: {
    height: "100%",
  },
  boxMain: {
    flex: "1 0 auto",
    paddingTop: "1.5rem",
  },
  boxFooter: {
    flexShrink: 0,
  },
  costRealSub: {
    paddingTop: 0,
    paddingBottom: "20px",
  },
  paymentInfoButton: {
    marginBottom: "25px",
    paddingLeft: 0,
    paddingRight: 0,
  },
  divider: {
    backgroundColor: "#000000",
    margin: "1rem 0",
  },
  sum: {
    color: "primary.main",
    marginBottom: "2rem",
  },
};

export default divorceCostBoxStyle;
